<script>
    import { onMount } from 'svelte';
	import Router, {location, link} from 'svelte-spa-router';
	import {push, pop, replace} from 'svelte-spa-router';
    import { iddistribuidor, nombre } from '../store/distribuidor.js';
	import { jwt } from "../store/index.js";
    let nombres = $nombre;
	let idsuscripcion;
	let datos = [];
	let idddib = $jwt;
	let estado;
	function home(){
		push("/");
	}
	function clientes(){
		push("/clientes");
	}
	function perfil(){
		push("/perfil");
	}
	function tickets() {
		push('/tickets');
	}
	function katana() {
		push('/katana');
	}
	function descargas() {
		push('/descargas');
	}
	function loguin() {
		push('/login');
	}
	function conceptos() {
		push('/conceptos');
	}
	
</script>

<div class="top">
	<div class="contenedor">
		<div class="row1">
			<div class="logo">
				<img src="./img/logo.png" alt="">
			</div>
			<div class="menu">
				<ul class="nav">
					<li id="nombre">{nombres}<img src="./img/down.svg" alt="">
						<ul id="down">
							<li on:click={perfil}>Profile</li>
							<li on:click={clientes}>Client</li>
							<li on:click={conceptos}>Services</li>
							<li on:click={tickets}>Tickets</li>
							<li on:click={katana}>Katana</li>
							<li on:click={descargas}>Downloads</li>
							<li on:click={home}>Log Out</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
